export default {
    星财宝专户: 'Star Wealth Account',
    offline: {
        title: '"星财宝专户" has been taken offline.',
        message: 'Please update to the latest version of the app to view.',
    },
    确定: 'Confirm',
    lang: 'en',
    请在方框内横向正楷签署你的名字: 'Sign your name <span style="color: #ff6907;">in the box</span>.',
    前往认证: 'Go to Verify',
    前往认证popText: 'Star Wealth Account is for professional investors. Verification of HKD 8M assets required.',
    查看进度: 'Check Progress',
    查看进度popText: 'Your professional investor application is submitted. Click to check status.',
    请勾选协议: 'Agree to Terms',
    agreement: {
        title: 'Star Wealth Account by Fosun AM',
        本人已阅读并同意: 'I agree',
        星财宝专户全权委托投资管理协议: 'Star Wealth Account Agreement',
        及签署理财账户: 'and sign account',
        已确认: 'Confirmed',
        去测评: 'Assess',
        提示: 'Notice',
        '您尚未完成风险测评，无法开通星财宝专户相关服务，请尽快测评': 'Complete risk assessment to activate Star Wealth.',
        '您的风险测评结果已过期，无法开通星财宝专户相关服务，请尽快重新测评': 'Risk assessment expired, retake to activate.',
        重新测评: 'Retake',
        您当前的风险等级为: 'Risk level',
        riskServer: 'Star Wealth risk mismatch, service unavailable.',
        '您尚未开通理财账户，是否完成风险测评并开通？': 'Open financial account? Complete risk assessment.',
        本人已阅读并同意签署: 'I agree to sign',
        客户协议书: 'Client Agreement',
        请设置交易密码: 'Set transaction password for security.',
        前往设置: 'Go to Set',
        稳健型: 'Conservative (L1)',
        中度型: 'Moderate (L2)',
        均衡型: 'Balanced (L3)',
        增长型: 'Growth (L4)',
        进取型: 'Aggressive (L5)',
    },
    riskDisclosure: {
        风险披露: 'Risk Disclosure',
        请点击下方播放按钮听取完整风险披露音频: 'Click to listen to risk disclosure.',
        我已确认自愿签署: 'I agree to sign',
        xieyi: 'Star Wealth Account Agreement',
        我已确认及同意使用和接收电子签名于: 'I agree to e-sign for',
        我已确认及明白: 'I understand Star Wealth risks, including fixed income, legal, and disclosure risks.',
        我已全权委托: 'I authorize Fosun AM to manage Star Wealth Account for cash management.',
        载明的范围: 'as specified',
        复星国际证券持牌代表: 'Fosun Securities Rep',
        资管持牌代表: 'Fosun AM Rep',
        下一步: 'Next',
        ypjzz: 'Audio Loading',
        音频加载中: 'Audio Loading',
        图片加载中: 'Image Loading',
        bs: 'Speed',
        0: 'Normal',
        1: 'Cantonese',
    },
    本人已阅读并同意签署:
        'I agree to sign Star Wealth Agreement, including Client Declaration, Fee Schedule, Investment Strategy, and Authorization.',
    status: {
        联系客服: 'Contact Support',
        资料审核不通过: 'Review Failed',
        重新签名: 'Resign',
        开通失败: 'Activation Failed',
        重新申请: 'Reapply',
        开通成功: 'Activated',
        账户号码: 'Account Number',
        买入产品: 'Buy Product',
        资料审核中: 'Review in Progress',
        '预计1-2个工作日开通': 'Activate in 1-2 days',
        完成: 'Done',
    },
}
